const config = {
    readonly: false,
    height: '400px',
    // buttons: [
    //     'source',
    //     'bold', 'underline', 'italic', 'outdent', 'indent',
    //     'font', 'fontSize', 'brush', 'paragraph',
    //     'image', 'file', 'table',
    //     'under', 'redo', 'selectAll', 'cut', 'copy', 'paste', 'about'
    // ],
    removeButtons: [
        'superscript',
        'subscript',
        'image',
        'file',
        'video',
        'hr',
        'symbol',
        'fullsize',
        'print',
        'about'
    ],
    toolbarAdaptive: false,
    uploader: {
        insertImageAsBase64URI : true
    }
};

export default config;